﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

export default class TKDashboardWidget extends TKCustomElementFactory {
    widgetId: string;
    widgetUrl: string;
    widgetLoadingClassName: string;

    constructor() {
        super();
        this.widgetId = this.getAttribute('data-tk-widget-id') || '';
        this.widgetUrl = this.getAttribute('data-tk-widget-url') || '';
        this.widgetLoadingClassName = this.getAttribute('data-tk-widget-loading-class-name') || 'tk-widget--loading';
    }

    connectedCallback(): void {
        if (this.widgetId === '') throw new Error('Account: Dashboard widget is missing!');
        this.getWidgetContent();
    }

    getWidgetContent(): void {
        this.classList.add(this.widgetLoadingClassName);
        fetchRequest({
            requestURL: `${this.widgetUrl}?wid=${this.widgetId}`,
            resolveHandler: this.renderResult.bind(this),
        }).finally(() => {
            this.classList.remove(this.widgetLoadingClassName);
        });
    }

    renderResult(response: TKResponse) {
        if (!response || !response.success) return;
        this.innerHTML = response.dataAsHtml;
    }
}
